import { getApi } from 'common/modules/ReactShared/data/api/apiClient';
import { IWordsIndexResponse, IWordsQuery } from './types';

const WORDS_PER_PAGE = 25;

export async function getWords(query: IWordsQuery = {}): Promise<IWordsIndexResponse> {
  const { page = 1, status, wordClass, level, q } = query;
  const { data } = await getApi().get<IWordsIndexResponse>('/profile/words', {
    params: {
      page,
      per_page: WORDS_PER_PAGE,
      status: status && status !== 'all' ? status : undefined,
      word_class: wordClass || undefined,
      level: level || undefined,
      q: q || undefined
    }
  });
  return data;
}

export async function starWord(wordId: number): Promise<void> {
  await getApi().post(`/words/${wordId}/student_words/star`);
}

export async function unstarWord(wordId: number): Promise<void> {
  await getApi().delete(`/words/${wordId}/student_words/star`);
}
